import cn from "classnames"
import styles from "@css/Components.module.scss"
import { Radio } from "@css/icons/SVG"
import { ChangeEvent, ReactNode, useState } from "react"

type RadioItem = {
    id: string
    value?: string
    label: ReactNode
}
type RadioButtonsProps = {
    items: RadioItem[]
    onChange?: (event: ChangeEvent<HTMLInputElement>) => void
    name: string
    value?: string // use value or default value
    classes?: {
        root?: string
        label?: string
    }
    defaultValue?: string // use value or default value
}
export function RadioButtons({ items, onChange, name, value, classes = {}, defaultValue }: RadioButtonsProps) {
    const [defValue] = useState<string | undefined>(() => defaultValue)
    const { root, label } = classes
    return (
        <div className={cn(root, styles.radioRoot)}>
            {items.map((i) => {
                const _value = i.value || i.id
                const props = value !== undefined ? { checked: value === _value } : { defaultChecked: defValue === i.id }
                return (
                    <label key={i.id} htmlFor={i.id} className={cn(label, styles.label)}>
                        <input onChange={onChange} {...props} id={i.id} type="radio" value={_value} name={name} />
                        <Radio />
                        {i.label}
                    </label>
                )
            })}
        </div>
    )
}
